import layoutPoints from 'echarts/lib/layout/points';
import { type EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import RankLineView from './RankLineView';
import RankLineSeries from './RankLineSeries';

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerChartView(RankLineView);
  registers.registerSeriesModel(RankLineSeries);

  registers.registerLayout(layoutPoints('dvRankLine', true));
}
